import {
    FaChartBar,
    FaExclamationTriangle,
    FaHardHat,
    FaInfoCircle,
    FaProjectDiagram,
    FaQuestion,
    FaShieldAlt,
    FaUserGraduate,
    FaUserShield,
    FaAccessibleIcon,
} from "react-icons/fa";
import { FcFilingCabinet } from "react-icons/fc";
import { SlipperyIcon } from "../../utils/functions";

export const menuIcons = {
    Incident: {
        icon: <FaExclamationTriangle />,
        color: "#ffc107",
        ethicalNote: "Report and Track HSE Incidents"
    },
    Inform: {
        icon: <FaInfoCircle />,
        color: "#0dcaf0",
        ethicalNote: "Share HSE Updates and Findings"
    },
    Competency: {
        icon: <FaUserGraduate />,
        color: "#f39c12",
        ethicalNote: "Develop the Users Competencies"
    },
    "Incident Reporting": {
        icon: <SlipperyIcon />,
        color: "#FFBF00",
        ethicalNote: "Report and Track HSE Incidents"
    },
    "Safety Communication": {
        icon: <FaInfoCircle />,
        color: "#0dcaf0",
        ethicalNote: "Share HSE Updates and Findings"
    },
    "Learning & Development": {
        icon: <FaUserGraduate />,
        color: "#f39c12",
        ethicalNote: "Develop the Users Competencies"
    },
    "System Admin": {
        icon: <FaUserShield />,
        color: "#198754",
        ethicalNote: "Manage users and system settings"
    },
    Project: {
        icon: <FaProjectDiagram />,
        color: "#0d6efd",
        ethicalNote: "Deliver projects responsibly"
    },
    "Permit To Work": {
        icon: <FaHardHat />,
        color: "#e67e22",
        ethicalNote: "Issue and Manage work permits"
    },
    Risk: {
        icon: <FaShieldAlt />,
        color: "#9b59b6",
        ethicalNote: "Identify and Assess HSE risks"
    },
    "Filing Cabinet": {
        icon: <FcFilingCabinet />,
        color: "#6c757d",
        ethicalNote: "Store and Access files securely"
    },
    Metrics: {
        icon: <FaChartBar />,
        color: "#198754",
        ethicalNote: "View Reports and Performance Data"
    },
    Accessibility: {
        icon: <FaAccessibleIcon />,
        color: "#0d6efd",
        ethicalNote: "Ensure equal access for all"
    }
}; 